"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parser_1 = require("./parser");
const lexer_1 = require("./lexer");
exports.PARTIAL = Symbol();
const constants = new Map([["π", Math.PI]]);
const functions = new Map([
    ["sin", Math.sin],
    ["cos", Math.cos],
    ["tan", Math.tan]
]);
class Visitor {
    constructor() {
        this.calculations = 0;
    }
    reset() {
        this.calculations = 0;
    }
    visit(node) {
        if (node == null) {
            return undefined;
        }
        return this.recursiveVisit(node);
    }
    recursiveVisit(node, partial) {
        if (node.type === "Additive") {
            return this.binaryOperationCase(node, partial, (a, b, op) => {
                if (op === lexer_1.PLUS) {
                    return a + b;
                }
                else {
                    return a - b;
                }
            });
        }
        else if (node.type === "UnaryNegative") {
            const ret = this.unaryOperationCase(node, partial, a => -a, true);
            // Do not count calculations for negative numbers.
            if (node.operand && node.operand.type !== "NumericLiteral") {
                this.calculations++;
            }
            return ret;
        }
        else if (node.type === "Multiplicative") {
            return this.binaryOperationCase(node, partial, (a, b, op) => {
                if (op === lexer_1.TIMES) {
                    return a * b;
                }
                else {
                    return a / b;
                }
            });
        }
        else if (node.type === "Power") {
            return this.binaryOperationCase(node, partial, (a, b) => Math.pow(a, b));
        }
        else if (node.type === "Sqrt") {
            return this.unaryOperationCase(node, partial, a => Math.sqrt(a));
        }
        else if (node.type === "MinusOnly") {
            return 0;
        }
        else if (node.type === "Group") {
            if (node.child != null) {
                return this.recursiveVisit(node.child);
            }
            return exports.PARTIAL;
        }
        else if (node.type === "FunctionOrConstant") {
            const isFunction = node.asFunction || node.args.length > 0;
            // `foo(`, `foo(1)`, `foo(1, 2)`, or `foo(1,`
            if (isFunction) {
                return this.evaluateFunction(node, partial);
            }
            const c = constants.get(node.name.value);
            // `foo`
            if (c != null) {
                return c;
            }
            else {
                // `interpreted as foo() without parenthesis`
                return this.evaluateFunction(node, partial);
            }
        }
        else {
            return node.value;
        }
    }
    evaluateFunction(node, partial) {
        const fn = functions.get(node.name.value);
        if (fn) {
            if (node.args.length < fn.length) {
                return exports.PARTIAL;
            }
            else if (node.args.length > fn.length) {
                throw new Error(`Invalid number of arguments for function: ${node.name.value}`);
            }
            const argValues = node.args.map(arg => this.recursiveVisit(arg, partial));
            if (argValues.some(v => v === exports.PARTIAL)) {
                return exports.PARTIAL;
            }
            return fn(...argValues);
        }
        else {
            throw new Error(`Invalid function: ${node.name.value}`);
        }
    }
    binaryOperationCase(node, partial, op) {
        if (partial && node.partial) {
            throw new Error("Nested partial expressions are not allowed.");
        }
        const operands = node.operands.map(n => this.recursiveVisit(n, partial || node.partial));
        this.calculations += node.operands.length - 1;
        if (operands.length === 1) {
            return operands[0];
        }
        return operands.reduce((a, b, i) => {
            if (b === exports.PARTIAL)
                return a;
            return op(a, b, node.operators[i - 1].type);
        });
    }
    unaryOperationCase(node, partial, op, noCount = false) {
        if (partial && node.partial) {
            throw new Error("Nested partial expressions are not allowed.");
        }
        if (!node.operand) {
            return exports.PARTIAL;
        }
        if (node.operator) {
            const r = this.recursiveVisit(node.operand, partial || node.partial);
            if (r === exports.PARTIAL) {
                return r;
            }
            if (!noCount) {
                this.calculations += 1;
            }
            return op(r);
        }
        else {
            return this.recursiveVisit(node.operand, partial || node.partial);
        }
    }
}
exports.Visitor = Visitor;
const staticVisitor = new Visitor();
function visitAst(ast) {
    staticVisitor.reset();
    return {
        result: staticVisitor.visit(ast),
        calculations: staticVisitor.calculations
    };
}
exports.visitAst = visitAst;
function visitString(input) {
    return visitAst(parser_1.parseString(input));
}
exports.visitString = visitString;
//# sourceMappingURL=visitor.js.map